import styled from 'styled-components'

import Image from '@components/Image'

export const FixedBarWrapper = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: ${({ fixed }) => (fixed ? 'fixed' : 'static')};
  z-index: 3;

  padding: 16px;
  background-color: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 30px 0px;
  animation: fadein 0.5s;

  box-sizing: border-box;
  width: 100%;

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`

export const GympassLogo = styled(Image)`
  height: 18px;

  @media (min-width: 768px) {
    height: 100%;
  }
`
